import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-64 px-4">
          <span className="material-symbols-outlined text-6xl text-danger mb-4">error</span>
          <h2 className="text-text-primary text-xl font-bold mb-2">發生錯誤</h2>
          <p className="text-gray-500 dark:text-gray-400 text-sm text-center mb-4">
            抱歉，應用程式遇到了問題。請重新整理頁面或稍後再試。
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
          >
            重新整理
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;